<template>
  <div
    class="form-group"
  >
    <template v-if="horizontal">
      <div class="form-row align-items-center">
        <div class="col-md-8">
          <label
            :for="id"
            :class="{'up': labelIsUp}"
            class="mb-0"
          >{{ label }}
            <span
              v-if="required"
              class="required"
            >*</span>
          </label>
        </div>
        <div class="col-md-4">
          <slot />
        </div>
      </div>
    </template>
    <template v-else>
      <div class="d-flex justify-content-between">
        <label
          v-if="!noLabel"
          :for="id"
          :class="{'up': labelIsUp}"
        ><slot name="label">{{ label }}</slot>
          <span
            v-if="required && !noAsterisk"
            class="required"
          >*</span>
        </label>
      </div>
      <slot />
    </template>
  </div>
</template>
<script>

export default {
  name: 'BasicFormGroup',
  props: {
    required: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    labelIsUp: {
      type: Boolean,
      default: false
    },
    hint: {
      type: String,
      required: false,
      default: null
    },
    horizontal: {
      type: Boolean,
      default: false
    },
    noAsterisk: {
      type: Boolean,
      default: false
    },
    noLabel: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
  span.required {
    color: #9e0000;
  }
  .form-group {
    margin-bottom: 15px;
    margin-top: 15px;
  }
</style>
